import type { SxProps, Theme } from '@mui/material/styles';

const indicationComparisonBlockStyles = {
  root: {
    mb: 4,
    pb: 4,
    borderBottom: 4,
    borderColor: 'grey.100'
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 1,
    mb: 2
  },
  titleTypography: {
    fontWeight: 'bold'
  },
  textField: {
    minWidth: 320
  }
} as const satisfies Record<string, SxProps<Theme>>;

export default indicationComparisonBlockStyles;
